import { Skeleton } from './skeleton';

export function PermissionLoader() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-8">
      <div className="w-full max-w-md space-y-6 text-center">
        <div>
          <img src="/goreeva_logo.png" alt="Goreeva" className="mx-auto h-auto w-48 opacity-50" />
        </div>
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold tracking-tight text-muted-foreground">
            Verifying Permissions
          </h1>
          <p className="text-sm text-muted-foreground/80">
            Please wait while we configure your workspace.
          </p>
        </div>
        <div className="space-y-3 pt-4">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-2/3" />
        </div>
      </div>
    </div>
  );
}
